import App from './App'

export { default as CloseButton } from './components/CloseButton'

export default App
